<!--
 * @Author: 陆伟
 * @Date: 2020-01-03 17:28:23
 * @LastEditors: duiying
 * @LastEditTime: 2021-07-27 17:11:23
 * @Description: 
 -->
<template>
  <!--  -->
  <div class="register" v-if="showFlag" @click.self="closeDialog">
    <div class="content">
      <div class="item">
        <input 
          class="input"
          type="tel" 
          placeholder="输入手机号码领取" 
          maxlength="11" 
          v-model="loginTel"
        />
        <i :class="countDownSecond > 0 ? 'gray':''" @click.stop="getCode">{{codeText}}</i>
      </div>
      <div class="item">
        <input 
          type="tel" 
          placeholder="输入验证码" 
          maxlength="6" 
          autocomplete="off" 
          v-model="loginCode"
        />
      </div>
      <img src="./zhuce_btn.png" alt="" class="btn" @click="handleRegister">
      <p>注册或确认即同意<a href="//static.yunjiweidian.com/493de1285a35bef82fe1199501a6acb3">《云集服务协议》</a>和<a href="http://static.yunjiweidian.com/8b91f0c044804cf6c1d1bacb55f4ba66">《隐私政策》</a></p>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
// import Vue from 'vue'
import { Toast } from '@yunji/h5'
import * as Http from '@/pages/commodity/api/share'
import { createTicketByMj } from '@/pages/commodity/common/js/fingerprintDevice'

// Vue.use(Dialog)

export default {
  data() {
    return {
      showFlag: false,
      tick: '',
      codeText: '发送验证码',
      loginTel: '',
      loginCode: '',
      countDownSecond: 0,
      pageInfo: {},
      telType: -1 // 手机号状态 0可注册 1vip 2会员
    }
  },
  methods: {
    showDialog() {
      this.showFlag = true
      if(!this.tick) {
        createTicketByMj().then((res) => {
          console.log('res::', res)
          this.tick = res.tick || ''
        })
      }
    },
    closeDialog() {
      this.showFlag = false
    },
    getCode() {
      if (this.countDownSecond > 0) return
      
      if (this.loginTel.trim() === '') {
        Toast('请输入手机号码')
        return
      }

      if (this.isValidate()) {
        this.judgeMemberRegister()
      }
    },
    judgeMemberRegister() {
      if (this.isClickGetCode) return
      
      this.isClickGetCode = true

      Http.judgeMemberRegister({
        phone: this.loginTel
      }).then((res) => {
        if (res.code === 0 && res.data && typeof res.data.flag === 'number' && res.data.flag > -1) {
          this.telType = res.data.flag
          this.getVerifyingCode()
        } else {
          this.isClickGetCode = false
          Toast(res.msg || '获取手机号信息异常，请稍后再试')
        }
      }).catch((e) => {
        this.isClickGetCode = false
        Toast('获取手机号信息异常，请稍后再试')
      })
    },
    getVerifyingCode() {
      const ua = window.navigator.userAgent
      Http.generateSmsCodeCommon({
        phone: this.loginTel,
        scenNo: 100121,
        riskParams: JSON.stringify({
          deviceId: '',
          appVersion: '',
          deviceModel: ua.split('(')[1].split(')')[0],
          manufacturer: ua.split('(')[1].split(')')[0],
          os: ua.split('(')[1].split(')')[0],
          osVersion: ua.split('(')[1].split(')')[0],
          screenWidth: window.outerWidth,
          screenHeight: window.screen.height || window.screen.availHeight,
          tick: this.tick
        })
      }).then((res) => {
        this.isClickGetCode = false
        if (res.errorCode === 0) {
          this.timeCountDown()
        } else {
          Toast(res.errorMessage || '服务异常，请稍后重试')
        }
      }).catch(() => {
        this.isClickGetCode = false
        Toast('服务异常，请稍后重试')
      })
    },
    timeCountDown() {
      let timer = 60000
      this.codeText = '重新获取（60s）'
      this.countDownSecond = timer / 1000
      this.codeTimer = setInterval(() => {
        timer -= 1000
        if (timer <= 0) {
          clearInterval(this.codeTimer)
          this.codeText = '重新获取'
          this.countDownSecond = -1
        } else {
          this.countDownSecond = timer / 1000
          this.codeText = `重新获取（${this.countDownSecond}s）`
        }
      }, 1000)
    },
    isValidate() {
      let flag = true
      if (!new RegExp('^1[0-9]{10}$').test(this.loginTel)) {
        flag = false
        Toast('请填写正确的手机号码')
      }
      return flag
    },
    handleRegister() {
      if (this.isNull()) {
        if (this.isValidate()) {
          switch (this.telType) {
            case 0:
              this.registerMember()
              break
            case 1:
              this.bindingWeChat()
              break
            case 2:
              this.bindingWeChat()
              break
            default:
              Toast('服务异常，请稍后重试')
              break
          }
        }
      }
    },
    isNull() {
      let flag = true
      if (this.loginTel.trim() === '') {
        Toast('手机号不能为空!')
        flag = false
      } else if (this.loginCode === '' || this.loginCode.length < 6) {
        Toast('验证码输入错误!')
        flag = false
      }
      return flag
    },
    registerMember() {
      if (this.isClickRegister) return
      
      this.isClickRegister = true

      Http.registerMember({
        phone: this.loginTel,
        smsCode: this.loginCode,
        shopId: this.localShopId,
        activityType: 20,
        activitySource: ''
      }).then((res) => {
        this.isClickRegister = false
        if (res.code === 0) {
          Toast('注册成功')
          this.closeDialog()
          this.$emit('reloadPageInfo')
        } else {
          Toast(res.msg || res.errorMessage || '注册异常，请稍后再试')
        }
      }).catch(() => {
        this.isClickRegister = false
        Toast('注册异常，请稍后再试')
      })
    },
    bindingWeChat() {
      this.isClickRegister = true

      Http.bindingWeChat({
        phone: this.loginTel,
        smsCode: this.loginCode
      }).then((res) => {
        this.isClickRegister = false
        if (res.code === 0) {
          Toast('绑定成功')
          this.closeDialog()
          this.$emit('reloadPageInfo')
        } else {
          Toast(res.msg || res.errorMessage || '绑定异常，请稍后再试')
        }
      }).catch(() => {
        this.isClickRegister = false
        Toast('绑定异常，请稍后再试')
      })
    }
  }
}
</script>

<style scoped>
.register{position: fixed;left: 0;top: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, .7);z-index: 1000;}
.content{width: 5.62rem;height: 6.38rem;position: absolute;left: 50%;top: 50%;transform: translate3d(-50%, -50%, 0);background: url('./zhuce_bg.png') no-repeat;background-size: 100% 100%;padding-top: 1.5rem;}
.item{display: flex;justify-content: space-between;height: .68rem;margin: 0 .64rem .4rem .64rem;border-bottom: .5px solid #F4A117;}
.item .input{width: 100%;}
/* .item input{flex: 1;} */
.item i{color: #F10D3B;font-size: .24rem;line-height: .68rem;white-space: nowrap;}
.item i.gray{color: #666;}
.btn{display: block;width: 3.66rem;margin: 1.4rem auto 0 auto;}
.content p{font-size: .24rem;color: #fff;opacity: .7;text-align: center;transform: scale(.8);margin-top: -.1rem;}
.content p a{color: #fff;}
</style>
